import React from 'react';
import {
  Icon, Label,
} from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { errorMessage } from '@/utils/errors';

const ErrorLabel = ({ error, warning, onDismiss }) => {
  const intl = useIntl();
  return (
    <div className="aridhia-error-label float-r">
      <Label
        as="a"
        size="small"
        basic
        color={warning ? 'yellow' : 'red'}
      >
        {errorMessage(error, intl)}
        <Icon name="delete" onClick={onDismiss} />
      </Label>
    </div>
  );
};

export default ErrorLabel;
